import { ORDER_PARTNERS_PACKAGES } from '../../namespace/partners/order-partners-packages'
import { API } from '../../../../api/api'

export const orderPartnersPackages = {
  state: {
    list: [],
    activePackageId: null,
    address: null
  },
  mutations: {
    [ORDER_PARTNERS_PACKAGES.MUTATIONS.SET_LIST](state, list) {
      state.list = list
    },
    [ORDER_PARTNERS_PACKAGES.MUTATIONS.SET_ACTIVE_ID](state, id) {
      state.activePackageId = id
    },
    [ORDER_PARTNERS_PACKAGES.MUTATIONS.SET_ADDRESS](state, address) {
      state.address = address
    }
  },
  actions: {
    async [ORDER_PARTNERS_PACKAGES.ACTIONS.INIT_LIST]({ commit }, address) {
      try {
        const response = (await API.getPartnerPackageItems(address)).data
        commit(ORDER_PARTNERS_PACKAGES.MUTATIONS.SET_LIST, response)
        commit(ORDER_PARTNERS_PACKAGES.MUTATIONS.SET_ADDRESS, address)
        return response
      } catch (e) {
        throw new Error('order partners packages request error')
      }
    }
  },
  getters: {
    [ORDER_PARTNERS_PACKAGES.GETTERS.ADDRESS](state) {
      return state.address
    },
    [ORDER_PARTNERS_PACKAGES.GETTERS.LIST](state) {
      return state.list
    },
    [ORDER_PARTNERS_PACKAGES.GETTERS.ACTIVE_ID](state) {
      return state.activePackageId
    },
    [ORDER_PARTNERS_PACKAGES.GETTERS.INCLUDED_ITEM](state) {
      if (state.activePackageId) {
        const rawItem = state.list.find(
          (item) => item.id === state.activePackageId
        )
        if (rawItem) {
          return {
            type: 'included',
            id: rawItem.id,
            name: rawItem.name,
            icon: rawItem.icon,
            quantity: 1,
            prices: {
              delivery: 0,
              monthly: rawItem.price
            }
          }
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}
